import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NonIframeLoginPage from './NonIframeLoginPage';
import IframeLoginPage from './IframeLoginPage';
import {
    selectors as bookmakersListSelectors,
    constants as bookmakersListConstants,
} from '../../../common/bookmakersList';
import { selectors as bookmakersInfoSelectors } from '../../../common/bookmakersInfo';

export const DrawerLoginPage = ({ match, name, loginType, containsTermsInLoginIframe }) => {
    const isNonIntegratedLoginForm = loginType === bookmakersListConstants.LOGIN_TYPE.IFRAME;
    return (
        isNonIntegratedLoginForm ? (
            <IframeLoginPage
                match={match}
                name={name}
                containsTermsInLoginIframe={containsTermsInLoginIframe}
            />
        ) : (
            <NonIframeLoginPage
                match={match}
                name={name}
            />
        )
    );
};

DrawerLoginPage.defaultProps = {
    containsTermsInLoginIframe: false,
};

DrawerLoginPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            bookmaker: PropTypes.string,
        }),
    }).isRequired,
    name: PropTypes.string.isRequired,
    loginType: PropTypes.string.isRequired,
    containsTermsInLoginIframe: PropTypes.bool,
};

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    );

const mapStateToProps = state => (
    { ...bookmakerInfoSelector(state) }
);

export default connect(
    mapStateToProps,
    null,
)(DrawerLoginPage);



// WEBPACK FOOTER //
// /src/js/drawer/components/LoginPage/LoginPage.jsx